export { default as Hero } from './Hero';
export { default as ValuePropositions } from './ValuePropositions';
export { default as WhatsCovered } from './WhatsCovered';
export { default as FinePrint } from './FinePrint';
export { default as ProtectIt } from './ProtectIt';



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/homepage/components/index.tsx